/**
 * Network — widget-first (2.1).
 * Platformový přehled veřejných URL (catalog network).
 * Publish/unpublish zůstává u owner modulů + PublishPanel; sjednocení UI později.
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('network');

export default function NetworkPage() {
  return <ModuleWorkspace def={DEF} hideHeader defaultTab='overview' />;
}
